//获取活动列表
const getActivityListUrl = `/gateway/hc-serve/miniapi/activity/activityList`;
//获取参与人列表
const getAtivityApplicantsListURL =
  "/gateway/hc-serve/miniapi/activity/activityApplicantsList";

//运营人员删除活动参与人
const getCancelActivityApplicationsByAdmin = `/gateway/hc-serve/miniapi/activity/cancelActivityApplicationsByAdmin`;
export {
  getActivityListUrl,
  getAtivityApplicantsListURL,
  getCancelActivityApplicationsByAdmin,
};
